
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.273 3.79a4.503 4.503 0 00-1.265-.159 4.452 4.452 0 00-1.161 8.723l.091.026a4.45 4.45 0 005.45-3.147.8.8 0 011.546.414 6.05 6.05 0 01-7.41 4.278l-.123-.034a6.05 6.05 0 114.471-11.184l.357-.628c.153-.268.542-.286.69-.03l1.874 3.246c.147.255-.063.583-.371.582l-3.709-.024a.363.363 0 01-.318-.55L10.08 4.1c-.26-.13-.53-.233-.807-.31z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    